// extracted by mini-css-extract-plugin
export var locationCard = "_ed-0";